import * as angular from "angular";
import {IHttpService, IPromise} from "angular";
import * as _ from "lodash";
import {ApiConfig} from "../../commons/models/api-config.model";
import {SplitService} from "../../commons/services/split-service.service";
import {ModelListWithCursor} from "../../commons/angular/models/model-list-with-cursor.model";
import {GeofenceLocationType, GeofenceZone, GeofenceZonesQueryParams} from "../models/geofence-zone.model";

export class GeofenceZoneRequests {

  // The AngularJS $http path: only the Angular HttpClient interceptor prepends apiConfig.baseUrl
  // and injects siteId. AngularJS services must add both manually (matches the existing
  // pattern in service-area-requests / account-requests).
  private base_url: string;

  /* @ngInject */
  constructor(private $http: IHttpService,
              private apiConfig: ApiConfig,
              private splitService: SplitService) {
    this.base_url = `${this.apiConfig.baseUrl}/geofenceZones`;
  }

  getAll(params?: GeofenceZonesQueryParams): IPromise<ModelListWithCursor<GeofenceZone>> {
    return this.$http
      .get<any>(this.base_url, {params: this._withSiteId(params)})
      .then((res) => this._normalizeListResponse(res.data));
  }

  getOne(geofenceZoneId: string): IPromise<GeofenceZone> {
    return this.$http
      .get<GeofenceZone>(`${this.base_url}/${geofenceZoneId}`, {params: this._withSiteId()})
      .then((res) => res.data);
  }

  getByLocation(locationType: GeofenceLocationType, locationId: string): IPromise<GeofenceZone> {
    return this.$http
      .get<GeofenceZone>(`${this.base_url}/${locationType}/${locationId}`, {params: this._withSiteId()})
      .then((res) => res.data);
  }

  create(locationType: GeofenceLocationType, locationId: string, zone: GeofenceZone): IPromise<GeofenceZone> {
    return this.$http
      .put<GeofenceZone>(`${this.base_url}/${locationType}/${locationId}`, zone, {params: this._withSiteId()})
      .then((res) => res.data);
  }

  update(geofenceZoneId: string, zone: GeofenceZone): IPromise<GeofenceZone> {
    return this.$http
      .post<GeofenceZone>(`${this.base_url}/${geofenceZoneId}`, zone, {params: this._withSiteId()})
      .then((res) => res.data);
  }

  deleteOne(geofenceZoneId: string): IPromise<void> {
    return this.$http
      .delete<void>(`${this.base_url}/${geofenceZoneId}`, {params: this._withSiteId()})
      .then(() => undefined);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _withSiteId(params?: any) {
    const merged = _.assign({}, params);
    if (!merged.siteId) {
      merged.siteId = this.splitService.getSiteId();
    }
    return merged;
  }

  private _normalizeListResponse(data: any): ModelListWithCursor<GeofenceZone> {
    if (_.isArray(data)) {
      return {list: data as GeofenceZone[], cursor: undefined};
    }
    return {
      list: _.get(data, 'list', []) as GeofenceZone[],
      cursor: _.get(data, 'cursor') || undefined
    };
  }
}

angular
  .module('bringoz.admin.service-areas')
  .service('geofenceZoneRequests', GeofenceZoneRequests);
